import { InvestorProfile } from '@/types/index';
import { apiClient } from './api-client';

export const investorProfileService = {
  get(): Promise<InvestorProfile> {
    return apiClient.get<InvestorProfile>('/auth/investor-profile');
  },

  update(data: Partial<InvestorProfile>): Promise<InvestorProfile> {
    return apiClient.patch<InvestorProfile>('/auth/investor-profile', data);
  },
};
